export default __webpack_public_path__ + "static/asmaosdapulpeira-8f5a41aea9730622cdacbab9ee60e690.webp";